import React from 'react'

export default function Fbcomments() {
  return (
    <>
      <div id="fb-root"></div>
    
      <div class="fb-comments" data-href="https://pfe-portfolio.netlify.app" data-width="" data-numposts="2"></div>
    </>
  )
}
